import { mainnet, sepolia, bsc, bscTestnet } from 'wagmi/chains'
import type { Chain } from 'viem'
import { isWeb3Testnet, web3NetworkMode } from './env'

/** 主网：Ethereum + BSC */
export const mainnetChains = [mainnet, bsc] as const

/** 测试网：Sepolia + BSC Testnet */
export const testnetChains = [sepolia, bscTestnet] as const

/** 当前环境启用的链（仅主网或仅测试网，不会同时暴露） */
export const supportedChains = isWeb3Testnet ? testnetChains : mainnetChains

export type SupportedChain = (typeof supportedChains)[number]

/** 当前环境默认链（Ethereum 系优先） */
export const defaultChain: Chain = supportedChains[0]

export { web3NetworkMode, isWeb3Testnet }

export const chainMeta: Record<
  number,
  { label: string; explorerUrl: string; isTestnet: boolean }
> = {
  [mainnet.id]: {
    label: 'Ethereum Mainnet',
    explorerUrl: mainnet.blockExplorers?.default.url ?? 'https://etherscan.io',
    isTestnet: false,
  },
  [sepolia.id]: {
    label: 'Sepolia',
    explorerUrl: sepolia.blockExplorers?.default.url ?? 'https://sepolia.etherscan.io',
    isTestnet: true,
  },
  [bsc.id]: {
    label: 'BNB Smart Chain',
    explorerUrl: bsc.blockExplorers?.default.url ?? 'https://bscscan.com',
    isTestnet: false,
  },
  [bscTestnet.id]: {
    label: 'BSC Testnet',
    explorerUrl: bscTestnet.blockExplorers?.default.url ?? 'https://testnet.bscscan.com',
    isTestnet: true,
  },
}

export function getChainLabel(chainId: number): string {
  return chainMeta[chainId]?.label ?? `Chain ${chainId}`
}

export function getExplorerAddressUrl(chainId: number, address: string): string {
  const base = chainMeta[chainId]?.explorerUrl ?? 'https://etherscan.io'
  return `${base}/address/${address}`
}

export function getExplorerTxUrl(chainId: number, hash: string): string {
  const base = chainMeta[chainId]?.explorerUrl ?? 'https://etherscan.io'
  return `${base}/tx/${hash}`
}

/** @deprecated 使用 defaultChain */
export const defaultDevChain = defaultChain
